/**
 * Kanban Constants
 */
// Constants for public events 
/** @hidden */
export var actionBegin = 'actionBegin';
/** @hidden */
export var actionComplete = 'actionComplete';
/** @hidden */
export var actionFailure = 'actionFailure';
/** @hidden */
export var cardClick = 'cardClick';
/** @hidden */
export var cardDoubleClick = 'cardDoubleClick';
/** @hidden */
export var cardRendered = 'cardRendered';
/** @hidden */
export var queryCellInfo = 'queryCellInfo';
/** @hidden */
export var dataBinding = 'dataBinding';
/** @hidden */
export var dataBound = 'dataBound';
/** @hidden */
export var dragStart = 'dragStart';
/** @hidden */
export var drag = 'drag';
/** @hidden */
export var dragStop = 'dragStop';
/** @hidden */
export var documentClick = 'document-click';
/** @hidden */
export var dialogOpen = 'dialogOpen';
/** @hidden */
export var dialogClose = 'dialogClose';
// Constants for internal events
/** @hidden */
export var contentReady = 'content-ready';
/** @hidden */
export var dataReady = 'data-ready';
/** @hidden */
export var bottomSpace = 25;
/** @hidden */
export var cardSpace = 16;
/** @hidden */
export var toggleWidth = 50;
